import { taxReturnsBaseUrl } from 'app/http/apiRoutes';
import httpApiApplication from 'app/http/httpApiApplication';

import { type ApproveTaxReturnDto, type RejectTaxReturnDto } from '../types';

export const baseUrl = taxReturnsBaseUrl;

class TaxreturnRequestService {
  approve(values: ApproveTaxReturnDto): Promise<unknown> | Promise<any> {
    return httpApiApplication
      .post(`${baseUrl}/approve`, values)
      .then((response: any) => ({ response }))
      .catch((error: any) => ({ error }));
  }

  reject(values: RejectTaxReturnDto): Promise<unknown> | Promise<any> {
    return httpApiApplication
      .post(`${baseUrl}/reject`, values)
      .then((response: any) => ({ response }))
      .catch((error: any) => ({ error }));
  }
}

export default new TaxreturnRequestService();
